import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export function setupMedicinaPreventiva(): void {
  const modules = [
    {
      entry: 'solicitar-participacao',
      id: 'solicitar-participacao',
      name: 'beneficiary.solicitar-participacao',
      route: Routes.SOLICITAR_PARTICIPACAO,
      order: 1,
      closeable: true,
    },
    {
      entry: 'historico-participacao',
      id: 'historico-participacao',
      name: 'beneficiary.historico-participacao',
      route: Routes.HISTORICO_PARTICIPACOES,
      order: 2,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'medicina-preventiva',
    id: 'medicina-preventiva',
    name: 'beneficiary.medicina-preventiva',
    modules,
    order: 10,
  });
}
